'use strict';


angular.module('core')
	.factory('EventTracker', ['Authentication', 'Raven', 'EntryMain', 'Teams', '$analytics', '$stateParams', '$q', function(Authentication, Raven, EntryMain, Teams, $analytics, $stateParams, $q) {
		var factory = {};


		/**
		 * Adds app information to event data
		 * @param eventData The event Data to enrich
		 * @private
		 */
		factory.__addAppData = function(eventData) {
			if (eventData.hasOwnProperty('app_id') || $stateParams.hasOwnProperty('mobileAppId')) {
				var deferred = $q.defer();

				// Track app id
				eventData.app_id = eventData.app_id || $stateParams.mobileAppId;

				EntryMain.loadMobileApp(eventData.app_id, false, function(err, appData) {
					if (!err && appData) {
						eventData.app_name = appData.name;
						eventData.app_role = appData.roleInApp;
						if (appData.team) {
							eventData.team_id = appData.team._id;
							eventData.team_name = appData.team.name;
						}
					}

					return deferred.resolve(eventData);
				});
				return deferred.promise;

			} else {
				return $q.when(eventData);
			}
		};


		/**
		 * Adds team information to event data
		 * @param eventData The event Data to enrich
		 * @private
		 */
		factory.__addTeamData = function(eventData) {

			if ((eventData.hasOwnProperty('team_id') || $stateParams.hasOwnProperty('teamId')) && !eventData.hasOwnProperty('team_name')) {
				// If there is a team-id but no name query it
				var deferred = $q.defer();

				eventData.team_id = eventData.team_id || $stateParams.teamId;

				Teams.get({
					teamId: eventData.team_id
				}, function(teamData) {
					eventData.team_name = teamData.name;
					return deferred.resolve(eventData);
				});

				return deferred.promise;
			} else {
				return $q.when(eventData);
			}

		};


		/**
		 * Adds language information to event data
		 * @param eventData The event Data to enrich
		 * @private
		 */
		factory.__addLanguageData = function(eventData) {

			// Language Data
			if ($stateParams.hasOwnProperty('languageId')) {
				// Track language id
				eventData.language_id = $stateParams.languageId;

				// Language name should also be available because app got loaded
				// already in a previous step
				if (EntryMain.languages.hasOwnProperty(eventData.language_id)) {
					// Track language name
					eventData.language_name = EntryMain.languages[eventData.language_id].name;
				}
			}

			return $q.when(eventData);
		};


		/**
		 * Checks if there is any additional data available and add
		 * it to the event data
		 * @param eventData The event Data to enrich
		 */
		factory.enrichEventData = function(eventData, callback) {
			var me = this;

			return me.__addAppData(eventData).then(
				function(data) {
					return me.__addTeamData(data);
				}
			).then(
				function(data) {
					return me.__addLanguageData(data);
				}
			);
		};


		/**
		 * Tracks an event
		 * @param eventName The name of the event to track like "Import Data"
		 * @param eventData Flat-Object containing strings with additional
		 *                  data to track
		 * @param noEnrich Does not try to additionally enrich the data, just
		 *                 logs as it is
		 */
		factory.track = function(eventName, category, eventData, noEnrich) {
			var me = this;

			if (!eventData) {
				eventData = {};
			}

			if (category) {
				eventData.category = category;
			}

			if (noEnrich !== true) {
				// Adds additional data to be tracked if available
				me.enrichEventData(eventData).then(
					function(data) {
						// Now actually send the track event
						$analytics.eventTrack(eventName, eventData);
					}
				);
			} else {
				$analytics.eventTrack(eventName, eventData);
			}
		};


		/**
		 * Sends the user data to the analytics provider
		 */
		factory.identifyUser = function() {
			var me = this;

			if (Authentication.user && Authentication.user._id) {
				var mixpanelUser = {
					$first_name: Authentication.user.firstName,
					$last_name: Authentication.user.lastName,
					$email: Authentication.user.email,
					$created: Authentication.user.created,
					provider: Authentication.user.provider
				};

				if (Authentication.user._billing) {
					mixpanelUser.planId = Authentication.user._billing.planId.toLowerCase();
					mixpanelUser.billingDataEntered = Authentication.user._billing.billingDataEntered;
				}

				$analytics.setUsername(Authentication.user._id);
				$analytics.setUserPropertiesOnce(mixpanelUser);

				// Identify the user also with Sentry
				Raven.setUserContext({
					email: Authentication.user.email,
					id: Authentication.user._id
				});
			}
		};

		factory.aliasUser = function() {
			if (Authentication.user && Authentication.user._id) {
				$analytics.setAlias(Authentication.user._id);
			}
		};

		return factory;
	}]);
